export const BIG_TEXT_ANIMATION_DELAY = 0.46;
export const DRAGGABLE_MASK_COVER_ANIMATION_DELAY = 1.1;
export const PARAGRAPGH_ANIMATION_DELAY = 1.43;
export const MOBILE_PARAGRAPGH_ANIMATION_DELAY = 0.46;
export const ARROW_ANIMATION_DELAY = 1.4;
